// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__gRXAQ","containerItemsCenter":"Skeleton_containerItemsCenter__2gMdY"};